import React, { memo } from 'react'
import styles from './option.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import { withPresentation } from '../../../../presentation-connectors'

const Option = memo(({ classes, children, onClick, answered, colors }) => {
  return (
    <div
      style={{ backgroundColor: colors.bgColor, color: colors.bgTextColor }}
      className={classNames(classes.container, {
        [classes.answered]: answered
      })}
      onClick={e => !answered && onClick(e)}>
      {children}
    </div>
  )
})

export default withPresentation(injectSheet(styles)(Option))
